import {
  SetAuthorEmailAction,
  SetCurrentPageAction,
  SetOptInNewsletterAction,
  SetShareWithOthersAction
} from '@src/actions/stencils/editor';
import {
  RedoAction,
  UndoAction,
  UpdateContentItemAction
} from '@src/actions/wysiwyg/editor';
import {
  WYSIWYG_EDITOR_REDO,
  WYSIWYG_EDITOR_UNDO,
  WYSIWYG_EDITOR_UPDATE_PAGE_CONTENT_ITEM
} from '@src/constants/wysiwyg_editor';
import {
  STENCIL_SET_CURRENT_PAGE,
  STENCIL_SUBMISSION_SET_AUTHOR_EMAIL,
  STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER,
  STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS
} from '../../constants/stencil';
import type { TStencilStorePageState } from '../../types/Stencil';

type Action =
  | SetCurrentPageAction
  | SetAuthorEmailAction
  | SetOptInNewsletterAction
  | SetShareWithOthersAction
  | UpdateContentItemAction
  | UndoAction
  | RedoAction;

const initialState = {
  currentView: 'build' as const,
  isDirty: false,
  lastHistoryWalk: null
};

function pageState(
  state: TStencilStorePageState = initialState,
  action: Action
): TStencilStorePageState {
  if (action.type === STENCIL_SET_CURRENT_PAGE) {
    return {
      ...state,
      currentView: action.payload
    };
  } else if (
    action.type === STENCIL_SUBMISSION_SET_AUTHOR_EMAIL ||
    action.type === STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER ||
    action.type === STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS ||
    action.type === WYSIWYG_EDITOR_UPDATE_PAGE_CONTENT_ITEM
  ) {
    return {
      ...state,
      isDirty: true
    };
  } else if (
    action.type === WYSIWYG_EDITOR_UNDO ||
    action.type === WYSIWYG_EDITOR_REDO
  ) {
    return {
      ...state,
      lastHistoryWalk: Date.now()
    };
  }

  return state;
}

export default pageState;
